export default {"src":"/_next/static/media/letter.db843fcc.svg","height":20,"width":22};